#import "~/graphql/fragments/User.graphql"

fragment Comment on Comment {
    id
    text
    created_at
    updated_at
    deleted_at

    video {
        id
    }

    user {
        ...User
    }
}
